module.exports = {
      id: "e6dd100480a65c7aa3f8e2d6abbb8e69water-well.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#e6dd100480a65c7aa3f8e2d6abbb8e69water-well.svg",
      toString: function () {
        return this.url;
      }
    }